<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KrGCn5/images/cover.jpg?1684514748623" alt="This image is the cover for the book Bully for You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bully for You
      </h1>
      <p class="bookDescription body article font2">
        <p>What could be hunkier than a cowboy? Not much, according to Martin Du Bois. He convinces two friends that a visit to the rodeo is every gay man’s wet dream, and so the three of them gaily (and I do mean gaily) set off to watch cowboy asses in action.</p> <p>A visit to a bar after the event gets Martin closer to the action than he ever thought possible, and he meets Jesse Cumberland, the man who caught his eye in the ring and made his rhinestones sparkle. Instant attraction leads to a one-night stand that gets under Martin’s insouciant skin and causes him to rethink his determination not to get involved emotionally. When Jesse invites Martin to his ranch, the visit is almost derailed by Martin’s realization that they lead very different lives. As a flaming city queer, he sees no way to fit with the solid, athletic Jesse. It’s up to Jesse to see if he can change Martin’s mind.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Catt Ford
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?512542e0